import styled from 'styled-components';
import { rem } from '../../utils';
export const StyledWrapper = styled.section `
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: center;
  background-color: ${({ theme }) => theme.Color.Brand.Lightest};
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
  padding: ${({ theme }) => rem(theme.Spacing.Size.MediumSmall)};
`;
export const StyledHeading = styled.article ``;
export const StyledDescription = styled.div ``;
export const StyledButtonWrapper = styled.div `
  margin-top: ${({ theme }) => rem(theme.Spacing.Size.MediumSmall)};
`;
//# sourceMappingURL=TextBanner.style.js.map